import { ICveNumber } from 'api/apiTypes';
import { ProductField } from 'component/layout/Update/field';
import { Filter } from 'component/Search/types';

/**
 * The list of filters to display on the CVE details page, in the
 * security updates lists.
 */
export const useSecurityUpdateCardFilterSettings = ({
  cveNumber,
}: ICveNumber): Filter[] => {
  const cveFilter: Filter = {
    type: 'always',
    apiName: 'cveNumber',
    value: {
      data: `'${cveNumber}'`,
      operator: 'eq',
    },
    metaName: 'cveNumber',
    dataName: 'cveNumber',
  };

  return [
    cveFilter,
    {
      dataName: 'productFamilyList',
      apiName: 'productFamilyId',
      metaName: 'productFamily',
      i18nName: 'productFamily',
      type: 'dropdown',
    },
    {
      dataName: 'productList',
      apiName: 'productId',
      metaName: 'product',
      i18nName: 'product',
      type: 'custom',
      // eslint-disable-next-line react/display-name
      onRender: () => <ProductField />,
    },
    {
      dataName: 'severityList',
      apiName: 'severityId',
      metaName: 'severity',
      i18nName: 'severity',
      type: 'dropdown',
    },
    {
      dataName: 'impactList',
      apiName: 'impactId',
      metaName: 'impact',
      i18nName: 'impact',
      type: 'dropdown',
    },
    {
      dataName: 'platformList',
      apiName: 'platformId',
      metaName: 'platform',
      i18nName: 'platform',
      none: 'zero',
      type: 'dropdown',
    },
  ];
};
